import { SettingsSubscriptionReferralProgramComponent } from './../settings-subscription-referral-program/settings-subscription-referral-program.component';
import { Component, OnInit, signal } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { AlertService } from '../alert.service';
import { SettingService } from '../setting.service';
import { OrganizationSubscription } from '../organization-subscription';
import { CardOnFile } from '../card-on-file';
import { SettingsSubscriptionsInvoicesComponent } from '../settings-subscriptions-invoices/settings-subscriptions-invoices.component';
import { SettingsSubscriptionsPaymentOptionsComponent } from '../settings-subscriptions-payment-options/settings-subscriptions-payment-options.component';
import { AddressFormComponent } from '../address-form/address-form.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { SettingsSubscriptionsListComponent } from '../settings-subscriptions-list/settings-subscriptions-list.component';
import { CurrencyPipe, DecimalPipe, NgIf } from '@angular/common';
import { UserRoleService } from '@main/user-role.service';


@Component({
    selector: 'app-settings-subscriptions',
    templateUrl: './settings-subscriptions.component.html',
    styleUrls: ['./settings-subscriptions.component.css'],
    imports: [NgIf, 
      DecimalPipe, CurrencyPipe,
      SettingsSubscriptionsListComponent, 
      FaIconComponent, ReactiveFormsModule, 
      AddressFormComponent, 
      SettingsSubscriptionsPaymentOptionsComponent, SettingsSubscriptionsInvoicesComponent, SettingsSubscriptionReferralProgramComponent]
})
export class SettingsSubscriptionsComponent implements OnInit {

  // Properties
  billingInformationForm: UntypedFormGroup;
  subscription: OrganizationSubscription;
  cardOnFile: CardOnFile;
  isFranchiseOwner = signal<boolean>(false);

  // Font Awesome Properties
  faSave = faSave;

  constructor(private settingService: SettingService,
    private alertService: AlertService,
    private userRoleService: UserRoleService) { }

  ngOnInit(): void {
    this.billingInformationForm = new UntypedFormGroup({
      name: new UntypedFormControl(),
      street: new UntypedFormControl(),
      city: new UntypedFormControl(),
      state: new UntypedFormControl('SAS'),
      postalCode: new UntypedFormControl()
    });

    this.isFranchiseOwner.set(this.userRoleService.isFranchiseOwner());
    this.getBillingInformation();
    this.getOrganizationSubscription()
    this.getCardOnFile()
  }

  // Get Billing Information
  private getBillingInformation(): void {
    this.settingService.getBillingInformation().subscribe((billingSettings) => {
      this.billingInformationForm.controls.name.setValue(billingSettings.name);
      const address = billingSettings.address;
      this.billingInformationForm.controls.street.setValue(address.street);
      this.billingInformationForm.controls.city.setValue(address.city);
      this.billingInformationForm.controls.state.setValue(address.state);
      this.billingInformationForm.controls.postalCode.setValue(address.postalCode);
    });
  }

  // Get Organization Subscription
  private getOrganizationSubscription(): void {
    this.settingService.getOrganizationSubscription('STANDARD').subscribe((subscription) => {
      this.subscription = subscription;
    });
  }

  // Get Card On File
  private getCardOnFile(): void {
    this.settingService.getCardOnFile().subscribe((cardOnFile) => {
      this.cardOnFile = cardOnFile;
    });
  }

  // Update Billing Information
  updateBillingInformation(): void {
    const data = {
      name: this.billingInformationForm.value.name,
      address: {
        street: this.billingInformationForm.value.street,
        city: this.billingInformationForm.value.city,
        state: this.billingInformationForm.value.state,
        postalCode: this.billingInformationForm.value.postalCode
      }
    };
    this.settingService.updateBillingInformation(data).subscribe(() => {
      this.alertService.showSuccessAlert('Billing Information Updated');
      this.getBillingInformation();
    });
  }

  // Billing Information Form Accessors
  get name() { return this.billingInformationForm.controls.name; }
}
